import * as React from 'react';

import { Button, IconButton, Typography } from 'omakase';
import { Grid } from 'ui';
import { IconMinus, IconPlusLarge } from '@tock/icons';
import { generateCounterProps } from '@tock/shared/utils/option';
import {
  modifierCompactFooter,
  modifierCompactRoot,
} from 'components/business/addons/ModifierCompactCssDefs';
import ModifierCompactItem from 'components/business/addons/ModifierCompactItem';

interface Props {
  id: number;
  description: string;
  disabled: boolean;
  isSoldOut: boolean;
  minRequiredIncrement: number;
  maxQuantity: number;
  name: string;
  onChangeQuantity(id: number, newQuantity: number): void;
  price: number;
  quantity: number;
  numFiredToKitchen: number;
}

const ModifierCompact: React.FunctionComponent<Props> = ({
  id,
  description,
  disabled = false,
  isSoldOut,
  minRequiredIncrement,
  maxQuantity,
  name,
  onChangeQuantity,
  price,
  quantity = 0,
  numFiredToKitchen,
}) => {
  const { disableDecrement, disableIncrement, handleIncrementQuantity, handleDecrementQuantity } =
    generateCounterProps({
      id,
      disabled,
      minRequiredIncrement,
      maxQuantity,
      onChangeQuantity,
      quantity,
      numFiredToKitchen,
    });

  return (
    <Grid item xs={12} md={12} css={modifierCompactRoot}>
      <div>
        <div css={modifierCompactFooter}>
          <ModifierCompactItem
            name={name}
            description={description}
            price={price}
            isSoldOut={isSoldOut}
          />
          <div className="button-row">
            {isSoldOut ? (
              <div>
                <Button
                  disabled
                  size="small"
                  variant="basic"
                  aria-label={`${name} sold out`}
                  data-testid={`supplement-disabled-supplement-id-${id}`}
                >
                  Sold out
                </Button>
              </div>
            ) : (
              <>
                {/* TODO: replace with quantity picker */}
                <IconButton
                  size="small"
                  variant="ghost"
                  aria-label={`Decrease ${name} quantity`}
                  data-testid={`supplement-minus-one-supplement-id-${id}`}
                  disabled={disableDecrement}
                  onClick={handleDecrementQuantity}
                >
                  <IconMinus />
                </IconButton>
                <Typography variant="body02Strong" component="span" className="quantity">
                  {quantity}
                </Typography>
                <IconButton
                  size="small"
                  variant="ghost"
                  aria-label={`Increase ${name} quantity`}
                  data-testid={`supplement-plus-one-supplement-id-${id}`}
                  disabled={disableIncrement}
                  onClick={handleIncrementQuantity}
                >
                  <IconPlusLarge />
                </IconButton>
              </>
            )}
          </div>
        </div>
      </div>
    </Grid>
  );
};

export default ModifierCompact;
